/** Warehouse ▸ Store e-Indents: the department asks the store for items (user, 2026-11-05). */
import { createFileRoute, redirect } from "@tanstack/react-router";
import { ListPageSkeleton } from "@/components/app/skeletons";
import { useAuth } from "@/features/auth/store";
import { useFacilities } from "@/features/auth/use-facilities";
import { IndentListPage } from "@/features/stores/components/indent-pages";

export const Route = createFileRoute("/_app/warehouse/store-indents/")({
  beforeLoad: () => {
    if (!useAuth.getState().can("stores.indent.raise.warehouse"))
      throw redirect({ to: "/" });
  },
  component: Page,
});

function Page() {
  const { selected, ready } = useFacilities();
  if (!ready) return <ListPageSkeleton />;
  return <IndentListPage facilityId={selected?.id} area="warehouse" />;
}
